/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AbsenteesRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let dateId = params.date_id;
    let periodId = params.period_id;
    let store = this.store;

    return hash({
      date: store.findRecord('date', dateId),
      period: store.findRecord('timetable/period', periodId),
      records: store.query('attendance/record', { dateId, periodId }),
    });
  }
}
